import { Component, input, output, Renderer2 } from '@angular/core'
import { AppPractice } from 'src/app/shared/services/ppv.api'
import { calendlyMappings } from '../calendly-mappings'
declare const Calendly: any

@Component({
   selector: 'vc-calendly-scheduler',
   templateUrl: './calendly-scheduler.component.html',
   styleUrl: './calendly-scheduler.component.scss',
   standalone: false,
})
export class CalendlySchedulerComponent {
   loadingSchedule = false
   selectedPractice = input<AppPractice>()
   calendlyEmail = input<string>()
   startDate = input<Date>()
   endDate = input<Date>()
   visible = input<boolean>(false)
   onEventScheduled = output<{ startTime: Date; endTime: Date; calendlyId?: string }>()

   constructor(private renderer: Renderer2) {
      this.renderer = renderer
   }

   ngOnInit(): void {
      this.loadCalendlyApp()
   }

   getCalendlyLink(): string {
      const email = this.calendlyEmail()
      const mapping = calendlyMappings.find((item) => item.workEmail?.toLowerCase() === email?.toLowerCase())
      console.log({ email, mapping })
      return mapping ? `https://calendly.com/${mapping.calendlyPage}` : ''
   }

   initCalendlyWidget(): void {
      const calendlyContainer = document.getElementById('calendly-container')
      if (calendlyContainer) {
         calendlyContainer.innerHTML = '' // Remove existing widget
      }

      if (typeof Calendly !== 'undefined') {
         const getCLink = this.getCalendlyLink()
         Calendly.initInlineWidget({
            //url: getCLink + '/pricing-discussion-review?hide_gdpr_banner=1&primary_color=01a978&date='+this.discussionAvailable+'&start_date='+this.discussionAvailable+'&end_date='+this.discussionComplete+'',
            url:
               getCLink +
               '/2025-pricing?hide_gdpr_banner=1&primary_color=01a978&date=' +
               this.startDate() +
               '&start_date=' +
               this.startDate() +
               '&end_date=' +
               this.endDate() +
               '',
            parentElement: document.getElementById('calendly-container'),
            prefill: {
               text: this.selectedPractice()?.name,
               customAnswers: {
                  a1: this.selectedPractice()?.name,
               },
            },
            utm: {},
         })

         window.addEventListener('message', (e) => {
            if (e.origin === 'https://calendly.com' && e.data.event && e.data.event.indexOf('calendly.event_type_viewed') === 0) {
               this.loadingSchedule = false
            }
         })
      } else {
         console.error('Calendly script not loaded.')
      }
   }

   public loadCalendlyApp() {
      const script = this.renderer.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      script.onload = () => {
         //this.initCalendlyWidget();
      }
      this.renderer.appendChild(document.body, script)

      function isCalendlyEventPicked(e) {
         return e.origin === 'https://calendly.com' && e.data.event && e.data.event.indexOf('calendly.date_and_time_selected') === 0
      }
      function isCalendlyEventScheduled(e) {
         return e.origin === 'https://calendly.com' && e.data.event && e.data.event.indexOf('calendly.event_scheduled') === 0
      }

      window.addEventListener('message', async (e) => {
         if (isCalendlyEventPicked(e)) {
            document.getElementById('scheduleText').style.opacity = '1'
         } else if (isCalendlyEventScheduled(e)) {
            this.loadingSchedule = true
            document.getElementById('calendly-container').style.opacity = '0'

            const eventUri = e.data.payload.event.uri

            if (eventUri) {
               try {
                  const response = await fetch(eventUri, {
                     headers: {
                        Authorization:
                           'Bearer eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzMzODcwNjQ4LCJqdGkiOiI3MDljY2U0NC0xMmExLTQyZGMtYTZkMC1jNWU4Y2M5MGUzYTQiLCJ1c2VyX3V1aWQiOiIwMWUzMzQzZi0zMTQ2LTQxYmEtYThmYi1hNWEyMDEzZDA2ZjQifQ.87IJE8B-FJxszoxBjzQSNISoLe3TR9JoGu8pBwzUKGWhcsWa4K378aPdsgCR8MpW9dQeFyQBjOMl3suiNqhAtg',
                        'Content-Type': 'application/json',
                     },
                  })

                  if (response.ok) {
                     const eventDetails = await response.json()
                     const localStartTime = new Date(eventDetails.resource.start_time)
                     const localEndTime = new Date(eventDetails.resource.end_time)

                     const mapping = calendlyMappings.find((item) => item.workEmail?.toLowerCase() === this.calendlyEmail()?.toLowerCase())
                     this.onEventScheduled.emit({
                        startTime: new Date(eventDetails.resource.start_time),
                        endTime: new Date(eventDetails.resource.end_time),
                        calendlyId: mapping ? mapping.calendlyPage : '',
                     })
                  } else {
                     console.error('Failed to fetch event details:', response.statusText)
                  }
               } catch (error) {
                  console.error('Error fetching event details:', error)
               }
            }

            this.loadingSchedule = false
            document.getElementById('calendly-container').style.opacity = '1'
         }
      })
   }
}
